/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Banking JSON Schemas 

const _BANK_ACCOUNT_BALANCE_RECORD_JSON_SCHEMA = {
    "$ref": "#/definitions/BankAccountBalanceRecordSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BankAccountBalanceRecordSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "record_uid": {
                    "reference_type": "uuid",
                    "title": "Record Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account_balance_record"
                },
                "recording_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recording Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "amount_in_cents",
                "bank_account_uid",
                "created_timestamp",
                "deposify_tags",
                "last_updated_timestamp",
                "notes",
                "record_uid",
                "recording_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BANK_ACCOUNT_JSON_SCHEMA = {
    "$ref": "#/definitions/BankAccountSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BankAccountSchema": {
            "additionalProperties": false,
            "properties": {
                "account_number": {
                    "title": "Account Number",
                    "type": "string"
                },
                "address_line_one": {
                    "title": "Address Line One",
                    "type": "string"
                },
                "address_line_three": {
                    "title": "Address Line Three",
                    "type": "string"
                },
                "address_line_two": {
                    "title": "Address Line Two",
                    "type": "string"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "bank_name": {
                    "title": "Bank Name",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "geo_state": {
                    "title": "Geo State",
                    "type": "string"
                },
                "interest_enabled": {
                    "title": "Interest Enabled",
                    "type": "boolean"
                },
                "interest_rate_per_annum": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Interest Rate Per Annum",
                    "type": "number"
                },
                "interest_rate_start_date": {
                    "format": "date-time",
                    "title": "Interest Rate Start Date",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "internal_type": {
                    "class_name": "BankAccountInternalType",
                    "enum": [
                        "DEPOSIFY_HELD",
                        "PARTNER_HELD",
                        "STRIPE_CONNECTED_ACCOUNT",
                        "STRIPE_PARTNER_CONNECTED_ACCOUNT"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "partner_account_uid": {
                    "reference_type": "uuid",
                    "title": "Partner Account UID",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "nickname": {
                    "title": "Nickname",
                    "type": "string",
                },
                "routing_number": {
                    "maxLength": 9,
                    "minLength": 9,
                    "title": "Routing Number",
                    "type": "string"
                },
                "name_on_account": {
                    "title": "Name On Account",
                    "type": "string"
                },
                "account_type": {
                    "class_name": "BankAccountType",
                    "enum": [
                        "checking",
                        "savings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "account_number",
                "address_line_one",
                "address_line_three",
                "address_line_two",
                "bank_account_uid",
                "bank_name",
                "created_timestamp",
                "deposify_tags",
                "geo_state",
                "interest_enabled",
                "interest_rate_per_annum",
                "interest_rate_start_date",
                "last_updated_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_JSON_SCHEMA = {
    "$ref": "#/definitions/BankAccountHistoricalInterestRateSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BankAccountHistoricalInterestRateSchema": {
            "additionalProperties": false,
            "properties": {
                "rate_history_uid": {
                    "reference_type": "uuid",
                    "title": "Rate History Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account_historical_interest_rate"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "interest_rate_per_annum": {
                    "format": "float",
                    "title": "Interest Rate Per Annum",
                    "type": "number"
                },
                "start_timestamp": {
                    "format": "date-time",
                    "title": "Start Timestamp",
                    "type": "string"
                },
                "end_timestamp": {
                    "format": "date-time",
                    "title": "End Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "rate_history_uid",
                "bank_account_uid",
                "interest_rate_per_annum",
                "start_timestamp",
                "end_timestamp",
                "deposify_tags",
                "created_timestamp",
                "last_updated_timestamp",
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BANK_ACCOUNT_INTEREST_JSON_SCHEMA = {
    "$ref": "#/definitions/BankAccountInterestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BankAccountInterestSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "archived": {
                    "title": "Archived",
                    "type": "boolean"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "interest_uid": {
                    "reference_type": "uuid",
                    "title": "Interest Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account_interest"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "recording_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recording Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "amount_in_cents",
                "archived",
                "bank_account_uid",
                "created_timestamp",
                "deposify_tags",
                "interest_uid",
                "last_updated_timestamp",
                "notes",
                "recording_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BANK_TRANSFER_JSON_SCHEMA = {
    "$ref": "#/definitions/BankTransferSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BankTransferSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "confirmation": {
                    "title": "Confirmation",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "destination_bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Destination Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "external_source": {
                    "title": "External Source",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "source_bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Source Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "state": {
                    "class_name": "BankTransferState",
                    "enum": [
                        "pending",
                        "complete"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "transfer_uid": {
                    "reference_type": "uuid",
                    "title": "Transfer Uid",
                    "type": "string",
                    "uid_resource_type": "bank_transfer"
                }
            },
            "required": [
                "amount_in_cents",
                "confirmation",
                "destination_bank_account_uid",
                "external_source",
                "notes",
                "source_bank_account_uid",
                "state",
                "transfer_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _BULK_FUNDS_TRANSFER_JSON_SCHEMA = {
    "$ref": "#/definitions/BulkFundsTransferSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "BulkFundsTransferSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "bulk_transfer_uid": {
                    "reference_type": "uuid",
                    "title": "Bulk Transfer Uid",
                    "type": "string",
                    "uid_resource_type": "bulk_funds_transfer"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "funds_destination": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_destination_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Destination Uid",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "amount_in_cents",
                "bulk_transfer_uid",
                "created_timestamp",
                "funds_destination",
                "funds_destination_uid",
                "funds_location",
                "funds_location_uid",
                "last_updated_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const BANK_ACCOUNT_BALANCE_RECORD_JSON_SCHEMA = _BANK_ACCOUNT_BALANCE_RECORD_JSON_SCHEMA.definitions.BankAccountBalanceRecordSchema;
export const BANK_ACCOUNT_JSON_SCHEMA = _BANK_ACCOUNT_JSON_SCHEMA.definitions.BankAccountSchema;
export const BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_JSON_SCHEMA = _BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_JSON_SCHEMA.definitions.BankAccountHistoricalInterestRateSchema;
export const BANK_ACCOUNT_INTEREST_JSON_SCHEMA = _BANK_ACCOUNT_INTEREST_JSON_SCHEMA.definitions.BankAccountInterestSchema;
export const BANK_TRANSFER_JSON_SCHEMA = _BANK_TRANSFER_JSON_SCHEMA.definitions.BankTransferSchema;
export const BULK_FUNDS_TRANSFER_JSON_SCHEMA = _BULK_FUNDS_TRANSFER_JSON_SCHEMA.definitions.BulkFundsTransferSchema;
